/** Tenant for Jira/GitHub incident-action connectors (matches backend remediation). */
export const INCIDENT_CLIENT_ID =
  process.env.REACT_APP_INCIDENT_CLIENT_ID || 'default';
